export const environment = {
  production: true,
  urlApi: "https://pentview-api.fxtestingapp.com",
  urlTradingWs: "",
  urlCrmWs: "https://pentview-api.fxtestingapp.com",
  languages: ["en", "es", "de", "ar", "zh-CN", "zh-TW", "he", "ru"],
  password: "bC#4nj_HM",
};
